module.exports = __webpack_public_path__ + "img/bitcoin4.1b54e8e1.png";